import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import urls from 'config/urls.json';
import { get } from 'utils/axios';

export const healthCheck = createAsyncThunk('HEALTH_CHECK', async (data, thunkAPI) => {
  const response = await get(urls.HEALTH_CHECK, {}, thunkAPI);
  return response.data;
});

const initialState = {
  showRightBar: false,
  containerHeight: 1000,
  windowSize: {
    height: 1000,
    width: 1000
  },
  isSM: false
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    reset: () => initialState,
    toggleRightBar: (state, { payload }) => {
      if (payload !== undefined) {
        state.showRightBar = payload;
      } else {
        state.showRightBar = !state.showRightBar;
      }
    },
    setWindowSize: (state) => {
      const { innerWidth, innerHeight } = window;
      const isSM = innerWidth < 768;
      state.isSM = isSM;
      state.containerHeight = isSM ? window.innerHeight - 140 : window.innerHeight - 70;
      state.windowSize = {
        height: innerHeight,
        width: innerWidth
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(healthCheck.pending, (state) => {
        //
      })
      .addCase(healthCheck.fulfilled, (state, action) => {
        //
      })
      .addCase(healthCheck.rejected, (state, action) => {
        //
      });
  }
});

export const { reset, toggleRightBar, setWindowSize } = settingSlice.actions;

export default settingSlice.reducer;
